<template>
    <div class="daily-quota clearfix" @click="onComponentClicked($event)">
        <button class="button" @click.prevent="step(-1)" :class="{'is-disabled': disabled}" v-if="!readOnly">-</button>
        <input class="input" type="number" :min="min" :max="max" step="1" v-model="internalValue" :class="{'is-disabled': disabled, 'is-danger': hasError && !disabled, 'is-warning': hasError && disabled}" v-if="!readOnly" />
        <button class="button" @click.prevent="step(1)" :class="{'is-disabled': disabled}" v-if="!readOnly">+</button>
        <span v-if="readOnly">{{ internalValue }}</span>
        <info-i v-if="disabled" :showI="false" :shown="flyoutShown" @hide="onHideFlyoutRequested()">
            {{ $t('availabilities.flyouts.plusMinusDisabled') }}
        </info-i>
        <info-i v-if="!disabled" :showI="false" :shown="flyout2Shown" @hide="onHideFlyoutRequested()">
            {{ $t('availabilities.flyouts.plusMinusTooLow') }}
        </info-i>
    </div>
</template>

<script>
    import { Tracking } from '../../../utils';
    import InfoI from './info-i';

    export default {
        name: 'daily-quota',

        components: {
            InfoI,
        },

        props: {
            value: {
                type: [Number, String],
                'default': 0,
            },
            min: {
                type: Number,
                'default': 0,
            },
            max: {
                type: Number,
                'default': 0,
            },
            disabled: {
                type: Boolean,
                'default': false,
            },
            readOnly: {
                type: Boolean,
                'default': false,
            },
            noFlyout: {
                type: Boolean,
                'default': false,
            },
        },

        data() {
            return {
                internalValue: this.value,
                flyoutShown: false,
                flyout2Shown: false,
                flyoutsAllowed: false,
            };
        },

        created() {
            setTimeout(() => {
                this.flyoutsAllowed = true;
            }, 100);
        },

        computed: {
            hasError() {
                return !this.valueIsLegal(this.internalValue, false);
            },
        },

        watch: {
            value(newVal, oldVal) {
                this.internalValue = newVal;
            },

            internalValue(newVal, oldVal) {
                if(isNaN(newVal) || newVal === null || newVal === undefined || newVal === '') {
                    this.$emit('error', true);
                    return;
                }

                if(newVal < this.min || newVal > this.max) {
                    this.$emit('error', true);
                    return;
                }

                if(newVal !== oldVal) {
                    this.$emit('input', newVal);
                }
                this.$emit('error', false);
            },

            flyoutShown(newVal, oldVal) {
                if(newVal && !oldVal) {
                    Tracking.trackEvent('AvailabilitiesByCampsite', 'disabledPlusminusControlClicked');
                    if(newVal) {
                        this.$emit('flyoutShown');
                    }
                }
            },
        },

        methods: {
            valueIsLegal(val, checkFlyout = true) {
                if(isNaN(val) || val === null || val === undefined || val === '') {
                    return false;
                }

                if(checkFlyout) {
                    this.flyout2Shown = val < this.min && val > -1 && !isNaN(val);
                    if((this.noFlyout && this.flyout2Shown) || !this.flyoutsAllowed) {
                        this.flyout2Shown = false;
                    }
                }

                return val >= this.min && val <= this.max;
            },
            step(s) {
                Tracking.trackEvent('AvailabilitiesByCampsite', 'plusminusControlClicked', s === -1 ? 'minus' : 'plus');
                if(this.valueIsLegal(this.internalValue + s)) {
                    this.internalValue += s;
                } else {
                    if(this.internalValue < this.min) {
                        this.internalValue = this.min;
                    } else if(this.internalValue > this.max) {
                        this.internalValue = this.max;
                    }
                }

                if(this.flyout2Shown) {
                    Tracking.trackEvent('AvailabilitiesByCampsite', 'plusminusControlClickedBelowAllowed');
                }
            },
            onComponentClicked(event) {
                if(this.disabled) {
                    this.flyoutShown = !this.flyoutShown;
                }
            },
            onHideFlyoutRequested() {
                if(this.disabled) {
                    this.flyoutShown = false;
                } else {
                    this.flyout2Shown = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    @import './daily-quota.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/daily-quota.vue